import React from 'react'
import { Col, Form, Row, TreeSelect } from 'antd'
import { FormikProps } from 'formik'
import { TreeNode } from 'antd/lib/tree-select/interface'
import { useTranslation } from 'react-i18next'

import { AssignTree, RoleGroupTrees, RoleType } from 'src/types'

import * as Values from '../initial-values'

interface Props {
  formikProps: FormikProps<Values.InitialValues>
  loadingTrees: boolean
  mapTreeRecursive(item: AssignTree): TreeNode
  trees: AssignTree[]
}

export default function UserRoleForm({
  formikProps,
  loadingTrees,
  mapTreeRecursive,
  trees
}: Props) {
  const { t } = useTranslation()
  function renderRoleTreeSelect(role_type: RoleGroupTrees['role_type']) {
    return (
      <TreeSelect
        loading={loadingTrees}
        onChange={values => {
          formikProps.setFieldValue('role_group_trees', [
            ...formikProps.values.role_group_trees.filter(
              role => role.role_type !== role_type
            ),
            ...formikProps.values.role_group_trees
              .filter(role => role.role_type === role_type)
              .reduce((previousValue, currentValue) => {
                const unchecked =
                  // @ts-ignore
                  values.findIndex(
                    // @ts-ignore
                    valueItem =>
                      +valueItem.value === +currentValue.assign_tree_id
                  ) < 0

                return [
                  ...previousValue,
                  {
                    ...currentValue,
                    ...(unchecked ? { active: false } : {})
                  }
                ]
              }, []),
            // @ts-ignore
            ...values.reduce((previousValue, currentValue) => {
              const isNew =
                formikProps.values.role_group_trees.findIndex(
                  role =>
                    role.role_type === role_type &&
                    +role.assign_tree_id === +currentValue.value
                ) < 0

              return [
                ...previousValue,
                ...(isNew
                  ? [
                      {
                        role_type,
                        assign_tree_id: +currentValue.value
                      }
                    ]
                  : [])
              ]
            }, [])
          ])
        }}
        searchPlaceholder={t('web.resources.currencies.name-search')}
        showArrow
        showSearch={false}
        size="large"
        style={{ width: '100%' }}
        treeCheckable
        treeCheckStrictly
        treeData={trees.map(mapTreeRecursive)}
        treeDefaultExpandAll
        // @ts-ignore
        value={formikProps.values.role_group_trees
          .filter(role => role.role_type === role_type && role.active !== false)
          .map(role => ({
            value: role.assign_tree_id
          }))}
      />
    )
  }
  return (
    <>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item colon={false} label="Gestor" hasFeedback>
            {renderRoleTreeSelect(RoleType.MANAGER)}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item colon={false} label="Aprovador" hasFeedback>
            {renderRoleTreeSelect(RoleType.APPROVER)}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item colon={false} label="Conferente" hasFeedback>
            {renderRoleTreeSelect(RoleType.CHECKER)}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item colon={false} label="Aprovador fechamento" hasFeedback>
            {renderRoleTreeSelect(RoleType.CONTROLLER)}
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
